/**
 * Shared paste-target rules for block semantic paste vs inline Tiptap paste.
 */

/**
 * Multiline body fields (notes, paragraphs, quotes) — always inline Tiptap paste.
 */
export function isMultilineBodyEditorPasteTarget(target) {
  if (!(target instanceof Element)) return false
  const field = target.closest('[data-nb-tiptap-field], [data-nb-tiptap-static]')
  if (!field) return false
  if (field.hasAttribute('data-nb-inline')) return false
  if (field.hasAttribute('data-single-line')) return false
  return true
}

/**
 * Block-level structured paste (bullets → rows, etc.) when not in a multiline body field.
 */
export function shouldOfferBlockSemanticPaste(target) {
  return !isMultilineBodyEditorPasteTarget(target)
}
